<div #divCategories>
    @for (subCategory of getCategories(values); track subCategory.id) {
        <a
            (click)="
                openCategoryFacet(
                    categoryId,
                    subCategory.id,
                    subCategory.name,
                    subCategory.totalNumber,
                    '*:relevance:categoryLevel2:' + subCategory.id,
                    divCategories,
                    false
                )
            "
            #popover="ngbPopover"
            class="btn-facet btn-sm category"
            [ngbPopover]="subcategories"
            [popoverContext]="{ query: generateCategoryQuery(subCategory), id: subCategory.id, name: subCategory.name }"
            [disablePopover]="categoryId === '0'"
            popoverClass="popover-default facet-subcategories-popover"
            placement="bottom"
            container="body"
            [ngClass]="{ selected: isSelected(subCategory) }"
            (mouseover)="openPopup(popover)"
            (mouseout)="clearPopupTimeout(popover)">
            {{ subCategory.name }}
            <span class="amount">{{ subCategory.totalNumber }}</span>
        </a>
    }
    @if (showToggle(values.length)) {
        <a class="btn-facet btn-sm category show-all" (click)="toggleShowAll()">
            <i class="aimo-icon icon-sm icon-inline" [ngClass]="showAll ? 'icon-minus-bold' : 'icon-plus-bold'"></i>
            <span>{{ (showAll ? 'aimo.product.hideCategories' : 'aimo.product.showCategories') | cxTranslate }}</span>
        </a>
    }
</div>

<ng-template #subcategories let-query="query" let-id="id">
    @if (getCategory(query + id) | async; as subCategories) {
        <div class="subcategories_wrapper">
            <ul class="subcategories">
                @for (subCategory of subCategories; track subCategory.code) {
                    <li>
                        <a
                            [tabindex]="0"
                            role="button"
                            (click)="
                                openCategoryFacet(
                                    id,
                                    id,
                                    subCategory.name,
                                    subCategory.count,
                                    query + subCategory.code,
                                    divCategories,
                                    true
                                )
                            "
                            class="btn-facet btn-sm category cursor-pointer"
                            [ngClass]="{ selected: subCategory.selected }"
                            [attr.aria-label]="
                                'productList.subCategory.arialLabel'
                                    | cxTranslate: { name: subCategory.name, count: subCategory.count }
                            ">
                            {{ subCategory.name }}
                            <span class="amount">{{ subCategory.count }}</span>
                        </a>
                    </li>
                }
            </ul>
        </div>
    }
</ng-template>
